/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { reduce, concat, find, orderBy } from 'lodash';
import PropTypes from 'prop-types';

import styles from './resultsTab.scss';
import PopOverMenu from '../../PopOverMenu';
import TabContentBase from '../TabContentBase';
import InfoButton from '../../InfoButton';
import CancellableInfo from '../../InfoPopUps/CancellableInfo';
import ResultsList from '../../ResultsList';
import links from '../../../../config/links';
import LoadingText from '../../text/LoadingText';
import PbrRating from '../../text/PbrRating';

import { getResultsData } from '../../../actions/profile-tab-actions';
import { useStatsig } from '../../hooks/useStatsig';

const _ = { reduce, concat, find, orderBy };

const GameTypes = {
    SINGLES: 'singles',
    DOUBLES: 'doubles',
    DINGLES: 'dingles',
};

const ResultsTab = (props) => {
    const {
        profileData,
        playerId,
        auth,
        isProProfile,
        displayCollegeRecruitingValues,
        history,
        selectedGameType,
        selectedYear,
        onGameTypeChange,
        onYearChange,
        isProfileIdUpdated,
        isUserLoggedIn,
    } = props;

    const { SINGLES, DOUBLES, DINGLES } = GameTypes;
    const { checkGate, featureGates } = useStatsig();
    const isDinglesEnabled = checkGate(featureGates.DINGLES);

    const gameTypeOptions = [
        { label: 'Singles', value: SINGLES },
        { label: 'Doubles', value: DOUBLES },
    ];

    if (isDinglesEnabled) {
        gameTypeOptions.push({
            label: 'Dingles',
            value: DINGLES,
        });
    }

    const dispatch = useDispatch();
    const { data, isLoading } = useSelector(({ profileTabData }) => profileTabData?.results || {});
    const results = data || {};
    const [yearOptions, setYearOptions] = useState([]);
    const [eligibleResults, setEligibleResults] = useState([]);
    const canPostScores = auth?.user && (playerId === auth?.user?.claimedPlayer?.playerId);

    useEffect(() => {
        if (isUserLoggedIn && !data && isProfileIdUpdated) {
            dispatch(getResultsData());
        }
    }, []);

    useEffect(() => {
        if (profileData) {
            const options = [];

            switch (selectedGameType) {
                case SINGLES:
                    profileData?.availableResultYearsSingles?.map((yearToMap) => {
                        options.push({
                            label: yearToMap,
                            value: yearToMap,
                        });
                    });
                    break;
                case DOUBLES:
                    profileData?.availableResultYearsDoubles?.map((yearToMap) => {
                        options.push({
                            label: yearToMap,
                            value: yearToMap,
                        });
                    });
                    break;
                case DINGLES:
                    profileData?.availableResultYearsDingles?.map((yearToMap) => {
                        options.push({
                            label: yearToMap,
                            value: yearToMap,
                        });
                    });
                    break;
                default:
                    break;
            }

            const sortedOptions = _.orderBy(options, 'value', 'desc');

            setYearOptions([{ label: 'Latest', value: 'last' }, ...sortedOptions]);

            if (profileData?.extendedRatingProfile?.eligibleResults) {
                if (selectedGameType === SINGLES) {
                    setEligibleResults(profileData.extendedRatingProfile.eligibleResults.singles);
                } else {
                    setEligibleResults(profileData.extendedRatingProfile.eligibleResults.doubles);
                }
            }
        }
    }, [profileData, selectedGameType]);

    const calculateResultCount = (singles, doubles) => {
        return _.reduce(_.concat(singles, doubles), (sum, rec) => { return sum + rec.value; }, 0);
    };

    const handleYearChange = (year) => {
        onYearChange(year.value);
    };

    const handleOnGameTypeChange = (type) => {
        onGameTypeChange(type.value);
    };

    const yearDefaultOption = selectedYear === 'last' ? 'Latest' : selectedYear?.toString();
    const showMyUtr = results?.myUtrRating ? (results?.myUtrRating.show || false) : false;
    const showVerifiedUtr = results?.utrRating ? (results?.utrRating.show || false) : false;
    const pbrDisplay = profileData.ratingChoice == 'ProgressionBallRating' && results?.utrRating?.pbrRatingDisplay;
    const resultCount = (profileData?.resultCountsSingles && profileData?.resultCountsDoubles) ? calculateResultCount(profileData.resultCountsSingles, profileData.resultCountsDoubles) : 0;
    const hasWithdrawls = results?.withdrawls > 0;
    const redirectUrl = `/profiles/${playerId}?t=1`;

    return (
        <TabContentBase
            displayOnlyMainContent={false}
            profileData={profileData}
            className={`${styles.resultsTab}`}
            isUserLoggedIn={isUserLoggedIn}
            displayCollegeRecruitingValues={displayCollegeRecruitingValues}
        >
            <div>
                <div className={`${styles.gameTypeContainer}`}>
                    <div className="d-inline-block">
                        <PopOverMenu
                            anchorClass={`${styles.anchorClass} pl8`}
                            menuItems={gameTypeOptions}
                            onSelected={handleOnGameTypeChange}
                            alignLeft={true}
                            data-testid="profile.results.game-type-dropdown"
                        >
                            <h6 className="text-uppercase title mt0 mb0">
                                {selectedGameType || 'Singles'} <i className={`${styles.arrow} uts uts-expand`} />
                            </h6>
                        </PopOverMenu>
                    </div>
                    <div className="d-inline-block ml16 border-left pl16">
                        <PopOverMenu
                            anchorClass={`${styles.anchorClass} pl8`}
                            menuItems={yearOptions}
                            onSelected={handleYearChange}
                            alignLeft={true}
                            data-testid="profile.results.year-dropdown"
                        >
                            <h6 className="text-uppercase title mt0 mb0">
                                {yearDefaultOption} <i className={`${styles.arrow} uts uts-expand`} />
                            </h6>
                        </PopOverMenu>
                    </div>
                </div>
                <div className="d-flex flex-row align-items-center mb8">
                    <div className="mr-auto">
                        {pbrDisplay && (
                            <PbrRating showLabel={true} pbrClass={styles.pbr} pbrRating={pbrDisplay} />
                        )}
                        {showVerifiedUtr && (
                            <>
                                <span className={`position-relative ${styles.verifiedUtr}`}>
                                    {results.utrRating.rating}
                                    <span className="verified16" title="Verified" />
                                </span>
                                {results.utrRating.ratingString}
                            </>
                        )}
                        {showVerifiedUtr && showMyUtr && ` \u2022 `}
                        {showMyUtr && (
                            <>
                                <span className="position-relative">
                                    {results.myUtrRating.rating}
                                </span>
                                    &nbsp;
                                {results.myUtrRating.ratingString}
                            </>
                        )}
                        {(showVerifiedUtr || showMyUtr) && (
                            <InfoButton
                                hoverText={(
                                    <>
                                        Please see <a href={links.algorithmUnderstandingLink} target="_blank" rel="noopener noreferrer">Understanding the Algorithm</a> for how the ratings work.
                                    </>
                                )}
                            />
                        )}
                    </div>
                </div>
                {!!results?.wins && !!results?.losses && (
                    <div className="d-flex flex-row align-items-center mb48">
                        <div className="mr-auto position-relative">
                            W/L
                            <span className={`${styles.middleDot}`}>&nbsp;</span>
                            {`${results?.wins} - ${results.losses} ${hasWithdrawls ? `(${results.withdrawls} Walkovers)` : ''}`}
                            {hasWithdrawls && (
                                <CancellableInfo
                                    hoverText="Dummy"
                                    rootClass={styles.walkoverRootClass}
                                    title="Walkovers"
                                    description="Includes losses from walkovers and defaults before match begins"
                                    cancelText="Got it"
                                />
                            )}
                        </div>
                    </div>
                )}
                {isLoading ? (
                    <div>
                        <LoadingText text={'Loading Results'} />
                    </div>
                ) : (
                    <>
                        {profileData && !!results?.events?.length ? (
                            <ResultsList
                                showVerified={true}
                                eligibleResults={eligibleResults}
                                gameType={selectedGameType}
                                results={results}
                                auth={auth}
                                playerId={playerId}
                                showDecimalForOwn={true}
                                isProProfile={isProProfile}
                                resultsLoading={isLoading}
                                totalResultsCount={resultCount}
                                redirectUrl={redirectUrl}
                            />
                        ) : (
                            (canPostScores) ? (
                                <div className={`${styles.placeHolderGrid}`}>
                                    <div className={`${styles.overlay}`} />
                                    <div className={`${styles.actionWrapper}`}>
                                        <button
                                            type="button"
                                            className={`btn btn-primary btn-sm text-uppercase`}
                                            onClick={() => {
                                                history.push(`/post-score-select`);
                                            }}
                                            data-testid="profile.results.post-scores-btn"
                                        >
                                            Post Scores
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="row mt64">
                                    <div className="col-12">
                                        <p className="text-center">{`No ${selectedGameType} results have been posted yet`}<br />
                                            Check back for match results
                                        </p>
                                    </div>
                                </div>
                            )
                        )}
                    </>
                )}
            </div>
        </TabContentBase>
    );
};

ResultsTab.propTypes = {
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(ResultsTab);
